/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RiskLabelCount } from './RiskLabelCount';
import { RiskLabelCountFromJSON, RiskLabelCountFromJSONTyped, RiskLabelCountToJSON } from './RiskLabelCount';
import type { UseCaseName } from './UseCaseName';
import { UseCaseNameFromJSON, UseCaseNameFromJSONTyped, UseCaseNameToJSON } from './UseCaseName';

/**
 *
 * @export
 * @interface RiskProfileDimensionMatrix
 */
export interface RiskProfileDimensionMatrix {
  /**
   *
   * @type {UseCaseName}
   * @memberof RiskProfileDimensionMatrix
   */
  readonly useCase: UseCaseName;
  /**
   *
   * @type {Array<RiskLabelCount>}
   * @memberof RiskProfileDimensionMatrix
   */
  readonly riskLabelCounts: Array<RiskLabelCount>;
}

/**
 * Check if a given object implements the RiskProfileDimensionMatrix interface.
 */
export function instanceOfRiskProfileDimensionMatrix(value: object): value is RiskProfileDimensionMatrix {
  if (!('useCase' in value) || value['useCase'] === undefined) return false;
  if (!('riskLabelCounts' in value) || value['riskLabelCounts'] === undefined) return false;
  return true;
}

export function RiskProfileDimensionMatrixFromJSON(json: any): RiskProfileDimensionMatrix {
  return RiskProfileDimensionMatrixFromJSONTyped(json, false);
}

export function RiskProfileDimensionMatrixFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RiskProfileDimensionMatrix {
  if (json == null) {
    return json;
  }
  return {
    useCase: UseCaseNameFromJSON(json['use_case']),
    riskLabelCounts: (json['risk_label_counts'] as Array<any>).map(RiskLabelCountFromJSON),
  };
}

export function RiskProfileDimensionMatrixToJSON(
  value?: Omit<RiskProfileDimensionMatrix, 'useCase' | 'riskLabelCounts'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {};
}
